export default "5bb5cfec35d71038.svg"